import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-secondary-button',
  standalone: true,
  template: `
    <button
      [attr.type]="type"
      class="secondary-btn"
      [disabled]="disabled"
    >
      {{ label }}
    </button>
  `,
  styleUrls: ['./button-secondary.css']
})
export class SecondaryButtonComponent {
  @Input() label = '';
  @Input() disabled: boolean = false;
  @Input() type: 'button' | 'submit' = 'button';
}
